import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Form,
} from 'semantic-ui-react';
import { TRANSLATION_FILES } from '../../constants/translation';
import Validate from './Validate';

class Select extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    hideMessage: PropTypes.bool,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    loading: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    style: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    validation: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          validate: PropTypes.func,
          option: PropTypes.object,
        }),
      ]).isRequired,
    ),
    value: PropTypes.oneOfType([
      PropTypes.string,
    ]),
    validateName: PropTypes.string,
    validateLabel: PropTypes.string,
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
    options: PropTypes.arrayOf(
      PropTypes.object,
    ),
    selectOnBlur: PropTypes.bool,
    multiple: PropTypes.bool,
    t: PropTypes.func,
  }
  render() {
    const { t } = this.props;
    return (
      <Validate
        hideMessage={this.props.hideMessage}
        validation={this.props.validation}
        label={this.props.validateLabel || this.props.label}
        name={this.props.validateName || this.props.name}
        ref={this.props.validateRef}
        onChange={(e, data) => {
          // bubble up onChange
          if (this.props.onChange) {
            this.props.onChange(e, data);
          }
        }}
        style={this.props.style && this.props.style}
      >
        <Form.Select
          disabled={this.props.disabled}
          search
          fluid
          multiple={this.props.multiple}
          label={this.props.label}
          loading={this.props.loading}
          name={this.props.name}
          placeholder={this.props.placeholder}
          value={this.props.value}
          options={this.props.options}
          selectOnBlur={this.props.selectOnBlur}
          noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
        />
      </Validate>
    );
  }
}

const SelectWithTranslation = withTranslation([TRANSLATION_FILES.translation])(Select);

export default forwardRef((props, ref) => <SelectWithTranslation {...props} validateRef={ref} />);



// WEBPACK FOOTER //
// ./src/components/AppForm/Select.jsx